import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { mediaUrl } from "../lib/api";

export const Testimonials = ({ testimonials = [] }) => {
  if (!testimonials.length) return null;
  return (
    <section id="testimonios" data-testid="testimonials-section" className="relative bg-glg-black py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <Reveal><p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-blue">Testimonios</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-5xl">
              Lo que dicen nuestros clientes
            </h2>
          </Reveal>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <motion.blockquote
              key={t.id || i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="rounded-2xl border border-white/10 bg-glg-surface/60 p-7"
            >
              <Quote className="h-7 w-7 text-glg-blue/50" />
              <p className="mt-4 text-sm leading-relaxed text-white/70">{t.testimonial}</p>
              <footer className="mt-6 flex items-center gap-3">
                {t.image && <img src={mediaUrl(t.image)} alt={t.name} className="h-10 w-10 rounded-full object-cover" />}
                <div>
                  <div className="text-sm font-semibold text-white">{t.name}</div>
                  {t.company && <div className="text-xs text-white/50">{t.company}</div>}
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
